import {
    GETSUBMODULEMASTERFORADMIN_SUCCESS,
    GETSUBMODULEMASTERFORADMIN_FAILED,
    RESET_GETSUBMODULEMASTERFORADMIN,
    LOADING_GETSUBMODULEMASTERFORADMIN,
    NETWORK_ERROR_GETSUBMODULEMASTERFORADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetGetSubModuleMasterForAdminList = () => {
    return { type: RESET_GETSUBMODULEMASTERFORADMIN };
};

const GetSubModulesMasterForAdminLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETSUBMODULEMASTERFORADMIN });
    await adminServices
        .post("getSubModulemasterforadmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                
                case "success":
                    dispatch(getSubModuleMasterAdminListsuccess(res.data));
                    break;
                default:
                    dispatch(getSubModuleMasterAdminListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETSUBMODULEMASTERFORADMIN,
                payload: err
            });
        });
};


function getSubModuleMasterAdminListsuccess(data) {
    return {
        type: GETSUBMODULEMASTERFORADMIN_SUCCESS,
        payload: data
    };
}
function getSubModuleMasterAdminListFailed(data) {
    return {
        type: GETSUBMODULEMASTERFORADMIN_FAILED,
        payload: data
    };
}

export { GetSubModulesMasterForAdminLists, resetGetSubModuleMasterForAdminList }